import request from '@teetsh/app/src/utils/request';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { LivretEval } from '@teetsh/app/src/containers/Livrets/types/livret';
import livretKeys from '@teetsh/app/src/containers/Livrets/queries/keys';
import { useTranslation } from 'react-i18next';

export interface DuplicateLivretCompetenceDTO {
  id: string;
  matiereId: string;
  domaineId?: string;
}

function duplicateLivretCompetence({
  schoolyearId,
  schoolId,
  livretEleveId,
  competenceId,
  matiereId,
  domaineId,
}: {
  schoolyearId: string;
  schoolId: string;
  livretEleveId: string;
  competenceId: string;
  matiereId: string;
  domaineId?: string;
}) {
  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/livrets-eleves/${livretEleveId}/competences/${competenceId}/duplicate`;
  return request(requestURL, {
    method: 'POST',
    body: {
      matiereId,
      domaineId,
    },
  });
}

interface Props {
  livretEleveId: string;
  livretEvalId: string;
}

export function useDuplicateLivretCompetence(props: Props) {
  const { notifySuccess, notifyError } = useNotification();
  const { schoolyear, school } = useSchoolSchoolyear();
  const { livretEleveId, livretEvalId } = props;
  const { t } = useTranslation(['carnet']);
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation<
    LivretEval,
    any,
    DuplicateLivretCompetenceDTO
  >({
    mutationFn: (competence: DuplicateLivretCompetenceDTO) =>
      duplicateLivretCompetence({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        livretEleveId,
        matiereId: competence.matiereId,
        domaineId: competence.domaineId,
        competenceId: competence.id,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: livretKeys.livretDetail(
          schoolyear.id,
          school.id,
          livretEvalId,
        ),
      });
      notifySuccess({
        title: t('carnet:messages.competence.createSuccess'),
      });
    },
    onError: () => {
      notifyError({
        title: t('carnet:messages.competence.createError'),
      });
    },
  });
  return mutateAsync;
}
